import classNames from 'classnames';
import { Button, SvgAnimation } from '@/components/standalone';
import styles from './AuditorsIntroSection.module.scss';

function AuditorsIntroSection() {
  return (
    <div
      className={classNames('section', styles.auditorsIntroSection)}
      id="first"
    >
      <div className="max-content-width">
        <div>
          <h1>Maximize your work as a web3 security company</h1>
          <p>
            Publish powerful audits that are smart & reactive objects, usable by
            everyone, while building your reputation with verifiable &
            insightful business metrics for free.
          </p>
          <div>
            <Button
              type="link"
              href="https://app.trustblock.run/sign-up?type=auditor"
              icon="LogIn"
            >
              Join now
            </Button>
            <Button
              type="link"
              mode="outline"
              href="https://app.trustblock.run"
            >
              Go to app
            </Button>
          </div>
        </div>
        <div>
          <SvgAnimation name="Auditors" autoplay />
        </div>
      </div>
    </div>
  );
}

export default AuditorsIntroSection;
